<template>
  <div id="app">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <nuxt/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  import BaseLayout from './base'
  import Vue from 'vue'
  import Vuetify from 'vuetify'

  Vue.use(Vuetify);

  export default {
    extends: BaseLayout,
    head() {
      let ret = {
        title: 'Dashboard',
        meta: [
          {
            name: 'robots',
            content: 'noindex, nofollow'
          }
        ],
        link: [
          {rel: 'icon', type: 'image/x-icon', href: this.$store.state.site.icon_file.filepath},
        ],
      };
      return ret;
    },
  }
</script>

<style lang="css" src="vuetify/dist/vuetify.min.css">
</style>
<style lang="css" src="material-design-icons-iconfont/dist/material-design-icons.css">
</style>
